"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUrlsInArraySingleOrg;

var _replaceBucketKeysWithUrls = _interopRequireDefault(require("./replaceBucketKeysWithUrls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Takes an array of data objects and swaps out any defined key/bucketKey
 * values with pre-signed urls in each item. Supports nested keys/subkeys.
 *
 * eg.
 *
 * [
 *  { foo: '/foo/foobar.jpg' },
 *  { foo: '/bar/barfoo.jpg' }
 * ], ['foo']
 *
 *    =>
 *
 * [
 *  { foo: 'aws.com/.../foo/foobar.jpg' },
 *  { foo: 'aws.com/.../bar/barfoo.jpg' }
 * ]
 *
 * @param {*} apiClient
 * @param {Array<Object>} dataArray
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @param {string} organisationId
 *
 * @return {Promise<*>}
 */
async function replaceBucketKeysWithUrlsInArraySingleOrg({
  apiClient,
  dataArray,
  substitutedKeys,
  organisationId,
  ignorePattern
}) {
  if (!dataArray || !dataArray.length) {
    return [];
  }

  const consolidatedObj = dataArray.reduce((acc, dataItem, index) => {
    const itemsToReplace = substitutedKeys.reduce((items, substitutedKey) => {
      // handle case where substitutedKeys are simple strings
      if (typeof substitutedKey !== 'object') {
        return { ...items,
          [`${index}|${substitutedKey}`]: dataItem[substitutedKey]
        };
      } // handle case where substitutedKeys are objects with key and subKey


      const {
        key,
        subKeys
      } = substitutedKey;
      const keyObj = dataItem[key];
      const subItemsToReplace = subKeys.reduce((subItems, subKey) => ({ ...subItems,
        [`${index}|${key}|${typeof subKey === 'string' ? subKey : subKey.key}`]: keyObj[subKey]
      }), {});
      return { ...items,
        ...subItemsToReplace
      };
    }, {});
    return { ...acc,
      ...itemsToReplace
    };
  }, {});
  const replacedMap = await (0, _replaceBucketKeysWithUrls.default)({
    apiClient,
    data: consolidatedObj,
    substitutedKeys: Object.keys(consolidatedObj),
    organisationId,
    ignorePattern
  });
  const refs = Object.keys(replacedMap);
  const replacedData = refs.reduce((acc, key) => {
    const ref = key.split('|');
    const targetIndex = parseInt(ref[0], 10);
    const parentKey = ref[1];
    const subKey = ref[2];
    const val = replacedMap[key]; // Handle two cases... with subKey and without

    const insert = subKey ? { ...acc[targetIndex],
      [parentKey]: { ...acc[targetIndex][parentKey],
        [subKey]: val
      }
    } : { ...acc[targetIndex],
      [parentKey]: val
    };
    acc.splice(targetIndex, 1, insert);
    return acc;
  }, dataArray);
  return replacedData;
}